/**
 * sizing-modals: 尺码页三个弹窗(尺码对照表 / 测量指南 / Sizing Kit 介绍)的开合。
 * 源自 web-hand-off sizing-modals.js：删 partials:loaded，补 shopify:section:load。
 *
 * [data-open-size-chart] → <dialog data-size-chart-dialog>
 * [data-open-sizing-guide] → <dialog data-sizing-guide-dialog>
 * [data-open-sizing-kit] → <dialog data-sizing-kit-dialog>(未开卖,纯介绍)
 * [data-close-*] / 点背板 / Esc(dialog 原生)关闭。无内容,数据在 HTML。
 * 弹窗打开时锁定页面滚动(html overflow hidden),close 事件统一恢复(含 Esc 关闭)。
 * 幂等,shopify:section:load 后重新初始化。
 */
(function () {
  function lockScroll() { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
  var PAIRS = [
    { open: '[data-open-size-chart]', dialog: '[data-size-chart-dialog]', close: '[data-close-size-chart]' },
    { open: '[data-open-sizing-guide]', dialog: '[data-sizing-guide-dialog]', close: '[data-close-sizing-guide]' },
    { open: '[data-open-sizing-kit]', dialog: '[data-sizing-kit-dialog]', close: '[data-close-sizing-kit]' },
  ];

  function wire(pair) {
    var dialog = document.querySelector(pair.dialog);
    if (!dialog) return;

    document.querySelectorAll(pair.open).forEach(function (btn) {
      if (btn.dataset.modalReady) return;
      btn.dataset.modalReady = '1';
      btn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        lockScroll();
      });
    });

    if (!dialog.dataset.modalReady) {
      dialog.dataset.modalReady = '1';
      dialog.querySelectorAll(pair.close).forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      // 点背板(dialog 本体,非内部 panel)关闭
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      // 无论何种方式关闭(× / 背板 / Esc)都会触发 close 事件 → 统一解锁滚动
      dialog.addEventListener('close', unlockScroll);
    }
  }

  function init() { PAIRS.forEach(wire); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
